import React, { useEffect, useRef, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";

//Redux
// import { useDispatch } from "react-redux";

//API
import toast from "react-hot-toast";
import { getTodaysData } from "../../../../common/Validations";
import { useReactToPrint } from "react-to-print";
import ERFPrintEwayBill from "./ERFPrintEwayBill";

const ERFEwayBillConfirmationModal = React.forwardRef((props, ref) => {
  // const dispatch = useDispatch();

  const [isCardVisible3, setCardVisible3] = useState(true);
  // eslint-disable-next-line
  const [disable, setDisabled] = useState(false);

  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  const [invoiceData, setInvoiceData] = useState();
  const [ewabilldata, setEwabilldata] = useState();
  const diableEwaybill = invoiceData?.e_WayBillNo;

  //print
  useEffect(() => {
    setPrintInvoiceData(props?.ewaybill);
  }, [props?.ewaybill]);

  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: `E-Way_Bill_${Math.floor(Math.random() * 1000000)}`,
  });

  // ewayBill
  // eslint-disable-next-line no-unused-vars
  // const [getDropdownData, setDropdownData] = useState("");

  //send print data
  const [printInvoiceData, setPrintInvoiceData] = useState();

  // useEffect(() => {
  //   setInvoiceData((invoiceData) => ({
  //     ...invoiceData,
  //     [getDropdownData?.textField]: getDropdownData?.name,
  //     [getDropdownData?.textCode]: getDropdownData?.code,
  //     [getDropdownData?.textDesc]: getDropdownData?.description,
  //   }));
  // }, [getDropdownData]);

  useEffect(() => {
    if (props?.ewaybill) {
      // Update invoiceData with totals
      setInvoiceData({
        ...props.ewaybill, // Preserve existing fields
        // items: updatedLineItems,
        // totals: calculatedTotals,
      });
    }
  }, [props?.ewaybill]);

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  //handle cancel modal
  // eslint-disable-next-line
  const handleCancel = () => {
    props.onHide();
  };

  const onInputChange = ({ target: { name, value } }) => {
    // setInvoiceData((invoiceData) => ({ ...invoiceData, [name]: value }));
    setEwabilldata((ewabilldata) => ({ ...ewabilldata, [name]: value }));
  };

  // eslint-disable-next-line
  const handleSave = async () => {
    const obj = {
      ...ewabilldata,
      ewayBill: invoiceData.ewayBill,
      invoiceNr: invoiceData.invoiceNr,
      loadingAdviceNr: invoiceData.documentNumber,
      generatedDate: invoiceData.generatedDate || getTodaysData(),
    };

    setDisabled(true);
    await ItemServiceV2.updateEwayBill(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "added successfully", {
          duration: 2000,
          position: "top-right",
        });
        props.onHide();
      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };

  // const documentTypeMap = {
  //   "101 - GST Registration": "GST",
  //   "100 - PAN Registration": "PAN",
  //   "131 - GST Registration": "GST",
  // };

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          E-Way Bill - {invoiceData?.e_WayBillNo}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/*03 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible3 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility3}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">ID</span>
                </Col>

                <Col xs={4} md={8} lg={8}>
                  <span className="headerTitle">E-Way Bill details</span>
                  <span className="subHeaderTitle">E-Way Bill details</span>
                </Col>
                {!!diableEwaybill && (
                  <Col xs={4} md={2} lg={2}>
                    <button className="btnTable" onClick={handlePrint}>
                      {" "}
                      <i class="bi bi-printer"></i> Print E-Way Bill
                    </button>
                    <div style={{ display: "none" }}>
                      <ERFPrintEwayBill
                        ref={contentRef}
                        data={printInvoiceData}
                      />
                    </div>
                  </Col>
                )}
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible3 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  {/*    <Col xs={12} md={12} lg={12}>
                   <div style={{ display: "block" }}>
                      <ERFPrintEwayBill ref={contentRef} data={printInvoiceData} />
                    </div>
                  </Col> */}
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        {!!diableEwaybill && (
                          <Row>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="E-WayBill Nr"
                                name="e_WayBillNo"
                                id="e_WayBillNo"
                                value={invoiceData?.e_WayBillNo}
                                // onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="E-Way Bill Status"
                                name="e_WayBillStatus}"
                                id="e_WayBillStatus}"
                                value={invoiceData?.e_WayBillStatus}
                                // onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                          </Row>
                        )}
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Generated Date"
                            name="generatedDate"
                            id="generatedDate"
                            type="date"
                            value={invoiceData?.generatedDate}
                            onChange={onInputChange}
                            disabled={!!diableEwaybill}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Customer Name"
                            name="customerName"
                            id="customerName"
                            value={invoiceData?.patientName}
                            onChange={onInputChange}
                            disabled={!!diableEwaybill}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Delivery Address"
                            name="deliveryAddress"
                            id="deliveryAddress"
                            value={invoiceData?.deliveryAddress}
                            onChange={onInputChange}
                            disabled={!!diableEwaybill}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Delivery PinCode"
                            name="deliveryPinCode"
                            id="deliveryPinCode"
                            value={invoiceData?.deliveryPinCode}
                            onChange={onInputChange}
                            disabled={!!diableEwaybill}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Gross Value"
                            name="grossValue"
                            id="grossValue"
                            value={invoiceData?.lineItemGrossTotal}
                            onChange={onInputChange}
                            disabled={!!diableEwaybill}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="CGST"
                            name="cgst"
                            id="cgst"
                            value={invoiceData?.cgst ?? 0}
                            onChange={onInputChange}
                            disabled={!!diableEwaybill}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="SGST"
                            name="sgst"
                            id="sgst"
                            value={invoiceData?.sgst ?? 0}
                            onChange={onInputChange}
                            disabled={!!diableEwaybill}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="IGST"
                            name="igst"
                            id="igst"
                            value={invoiceData?.lineItemTaxTotal}
                            onChange={onInputChange}
                            disabled={!!diableEwaybill}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Transport Id"
                            name="transportId"
                            id="transportId"
                            value={invoiceData?.transportId}
                            onChange={onInputChange}
                            disabled={!!diableEwaybill}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Transport Mode"
                            name="transportMode"
                            id="transportMode"
                            value={invoiceData?.transportMode}
                            onChange={onInputChange}
                            disabled={!!diableEwaybill}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Transporter Name"
                            name="transporterName"
                            id="transporterName"
                            value={invoiceData?.transporterName}
                            onChange={onInputChange}
                            disabled={!!diableEwaybill}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Transport Distance"
                            name="transportDistance"
                            id="transportDistance"
                            value={invoiceData?.transportDistance}
                            onChange={onInputChange}
                            disabled={!!diableEwaybill}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Transport Document Number"
                            name="transportDocNo"
                            id="transportDocNo"
                            value={invoiceData?.transportDocNo}
                            onChange={onInputChange}
                            disabled={!!diableEwaybill}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Transport Document Date"
                            name="transportDocDate"
                            id="transportDocDate"
                            value={invoiceData?.transportDocDate}
                            onChange={onInputChange}
                            disabled={!!diableEwaybill}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Vehicle Number"
                            name="vehicleNo"
                            id="vehicleNo"
                            value={invoiceData?.vehicleNo}
                            onChange={onInputChange}
                            disabled={!!diableEwaybill}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={3}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Vehicle Type"
                            name="vehicleType"
                            id="vehicleType"
                            value={invoiceData?.vehicleType}
                            onChange={onInputChange}
                            disabled={!!diableEwaybill}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
});

export default ERFEwayBillConfirmationModal;
